import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProfissionalEditarComponent } from './profissional-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ProfissionalEditarComponent }
    ])],
    exports: [RouterModule]
})
export class ProfissionalEditarRoutingModule { }
